import React from 'react';
import { motion } from 'framer-motion';
import { Leaf, Check, AlertTriangle, Sprout } from 'lucide-react';
import { Countdown } from './Countdown';
export function PricingSection() {
  return <section id="pricing" className="py-14 bg-petroleum relative overflow-hidden" data-id="element-454">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-electric to-transparent opacity-50" data-id="element-455"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-456">
        {/* Scarcity Header */}
        <div className="max-w-3xl mx-auto text-center mb-10" data-id="element-457">
          <div className="inline-flex items-center gap-2 bg-electric/10 text-electric border border-electric/20 px-4 py-2 rounded-full text-sm font-bold mb-5" data-id="element-458">
            <AlertTriangle className="w-4 h-4" data-id="element-459" />
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </div>

          <div className="mb-5" data-id="element-460">
            <Countdown data-id="element-461" />
          </div>

          <p className="text-textsecondary mb-2" data-id="element-462">
            ⚠️ Después sube $10.000 ARS. No vuelve.
          </p>
          <p className="text-energy font-medium flex items-center justify-center gap-2" data-id="element-463">
            72% de los cupos al precio de lanzamiento ya tomados
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-464">
          {/* Outer glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-electric via-energy to-electric rounded-3xl blur-xl opacity-40 animate-pulse" data-id="element-465"></div>

          {/* Frame */}
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-electric rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-electric/30" data-id="element-466">
            {/* Decorative sprout flourish in background */}
            <div className="absolute -top-16 -right-16 opacity-10 pointer-events-none rotate-45" data-id="element-467">
              <Sprout className="w-48 h-48 text-electric" data-id="element-468" />
            </div>
            <div className="absolute -bottom-16 -left-16 opacity-10 pointer-events-none -rotate-45" data-id="element-469">
              <Sprout className="w-48 h-48 text-electric" data-id="element-470" />
            </div>

            {/* Organic dot pattern background */}
            <div className="absolute inset-0 opacity-[0.18] pointer-events-none" style={{
            backgroundImage: 'radial-gradient(circle, rgba(125,255,47,0.35) 1.2px, transparent 1.5px)',
            backgroundSize: '18px 18px'
          }} data-id="element-471"></div>

            {/* Corner accents */}
            <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-electric rounded-tl-3xl pointer-events-none" data-id="element-472"></div>
            <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-electric rounded-tr-3xl pointer-events-none" data-id="element-473"></div>
            <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-electric rounded-bl-3xl pointer-events-none" data-id="element-474"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-electric rounded-br-3xl pointer-events-none" data-id="element-475"></div>

            <div className="relative z-10" data-id="element-476">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} className="inline-flex items-center gap-2 bg-electric text-graphite border border-electric px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-electric/40" data-id="element-477">
                <Sprout className="w-3.5 h-3.5" data-id="element-478" />
                Acceso Instantáneo
              </motion.div>
              <h2 className="text-3xl md:text-5xl font-extrabold flex items-center justify-center gap-3 flex-wrap" data-id="element-479">
                <Leaf className="w-7 h-7 md:w-9 md:h-9 text-gold fill-gold/30 drop-shadow-[0_0_8px_rgba(232,184,74,0.6)]" data-id="element-480" />
                <span className="text-white" data-id="element-481">ELEGÍ TU</span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric via-energy to-electric drop-shadow-[0_0_12px_rgba(125,255,47,0.4)]" data-id="element-482">
                  KIT
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-electric to-transparent opacity-70" data-id="element-483"></div>
            </div>
          </div>
        </motion.div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-484">
          {/* Basic Plan */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-graphite border border-white/10 rounded-3xl p-8 hover:border-electric/30 transition-all relative" data-id="element-485">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-petroleum border border-electric/40 text-electric font-bold px-4 py-1 rounded-full text-xs uppercase tracking-wider flex items-center gap-1.5" data-id="element-486">
              <Leaf className="w-3 h-3 fill-electric/40" data-id="element-487" /> Plan Esencial
            </div>

            <div className="mb-6 pt-2" data-id="element-488">
              <h3 className="text-2xl font-bold leading-tight mb-1.5 flex items-start gap-2" data-id="element-489">
                <Leaf className="w-5 h-5 text-electric fill-electric/40 mt-1 flex-shrink-0" data-id="element-490" />
                <span data-id="element-491">KIT NEGOCIO FITNESS IA</span>
              </h3>
              <p className="text-sm text-textsecondary" data-id="element-492">6 Tomos + 6 Bonos</p>
            </div>

            <div className="bg-petroleum rounded-xl p-4 mb-8" data-id="element-493">
              <p className="text-sm text-textsecondary mb-1" data-id="element-494">Ideal para:</p>
              <p className="font-medium" data-id="element-495">
                Profesionales que quieren empezar a vender online con un sistema
                completo desde cero.
              </p>
            </div>

            <div className="mb-8" data-id="element-496">
              <span className="text-textsecondary line-through text-xl" data-id="element-497">
                $36.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-498">
                <span className="text-4xl font-extrabold text-white" data-id="element-499">
                  $19.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-500">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCcl7gvQ5vY0b1hyVWyPac/es-ar?_r=AQABbv65Q0gCPXZYhJR_L9tgdXLybHYG3RIokQMwoWPr7Js&cart_link_id=HjseKSgA&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-petroleum to-petroleum/80 hover:from-electric/20 hover:to-electric/10 border border-electric/50 hover:border-electric text-white font-bold py-3.5 rounded-xl transition-all duration-300 flex items-center justify-between gap-3 pl-4 pr-2 shadow-md hover:shadow-lg hover:shadow-electric/20" data-id="element-501">
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 border border-electric/30 flex items-center justify-center group-hover:bg-electric/25 transition-colors" data-id="element-502">
                <Leaf className="w-4 h-4 text-electric fill-electric/40" data-id="element-503" />
              </span>
              <span className="flex-1 text-center text-sm md:text-base tracking-wide" data-id="element-504">
                QUIERO MI KIT
              </span>
              <span className="flex-shrink-0 w-8 h-8 rounded-lg bg-electric/15 text-electric flex items-center justify-center group-hover:translate-x-0.5 transition-transform" data-id="element-505">
                <Check className="w-4 h-4" strokeWidth={3} data-id="element-506" />
              </span>
            </a>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gradient-to-b from-[#13261a] to-petroleum border-2 border-electric rounded-3xl p-8 relative transform md:-translate-y-4 glow-electric" data-id="element-507">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-graphite font-bold px-4 py-1 rounded-full text-sm flex items-center gap-1" data-id="element-508">
              <Leaf className="w-4 h-4 fill-graphite/40" data-id="element-509" /> MÁS POPULAR
            </div>

            <h3 className="text-2xl font-bold mb-2 flex items-center gap-2" data-id="element-510">
              KIT + PROTOCOLO 24/7
            </h3>
            <p className="text-textsecondary mb-6" data-id="element-511">
              6 Tomos + 6 Bonos + El Protocolo de Ejecución 24/7
            </p>

            <div className="bg-graphite/50 rounded-xl p-4 mb-8 border border-gold/20" data-id="element-512">
              <p className="text-sm text-gold mb-1" data-id="element-513">Ideal para:</p>
              <p className="font-medium" data-id="element-514">
                Quien quiere su primera venta en 7 días con prompts clínicos
                avanzados, scripts de cierre y sistema de cobro automático.
              </p>
            </div>

            <div className="mb-8" data-id="element-515">
              <span className="text-textsecondary line-through text-xl" data-id="element-516">
                $49.990
              </span>
              <div className="flex items-baseline gap-2" data-id="element-517">
                <span className="text-5xl font-extrabold text-white" data-id="element-518">
                  $27.990
                </span>
                <span className="text-textsecondary font-medium" data-id="element-519">ARS</span>
              </div>
            </div>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNCclFbI7sWfiYKDB5A4UUc/es-ar?_r=AQABcFNgsdfWUaxaEwGfEodD0yzqrQmh0yGFx7BMeD6yBWU&cart_link_id=tRAHM9um&preview_theme_id=154708803747" target="_blank" rel="noopener noreferrer" className="group relative w-full bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 hover:from-yellow-200 hover:via-yellow-300 hover:to-gold text-graphite font-extrabold rounded-2xl transition-all duration-300 transform hover:-translate-y-1 shadow-[0_0_25px_rgba(232,184,74,0.5)] hover:shadow-[0_0_40px_rgba(232,184,74,0.85)] flex items-center justify-between gap-3 pl-3 pr-3 py-3 uppercase tracking-wide overflow-hidden border-2 border-yellow-200" data-id="element-520">
              {/* Animated sheen */}
              <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/40 to-transparent skew-x-12 pointer-events-none" data-id="element-521"></span>

              {/* Left icon badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite/15 backdrop-blur-sm flex items-center justify-center" data-id="element-522">
                <Leaf className="w-5 h-5 fill-graphite/40 text-graphite" data-id="element-523" />
              </span>

              {/* Centered label */}
              <span className="relative z-10 flex-1 text-center text-sm md:text-base leading-tight" data-id="element-524">
                QUIERO EL KIT + PROTOCOLO 24/7
              </span>

              {/* Right arrow badge */}
              <span className="relative z-10 flex-shrink-0 w-10 h-10 rounded-xl bg-graphite text-gold flex items-center justify-center transition-transform duration-300 group-hover:translate-x-0.5 shadow-md" data-id="element-525">
                <Check className="w-5 h-5" strokeWidth={3} data-id="element-526" />
              </span>
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}